import { __awaiter } from "tslib";
import { useMegaBroker } from './broker';
import ClientChannel from './client-channel';
import ClientChannelMobile from './client-channel-mobile';
class Client {
    constructor(protocols) {
        this.protocols = protocols;
    }
    static create(protocols, isMobile) {
        const client = new Client(protocols);
        client.init(isMobile);
        return client;
    }
    init(isMobile) {
        const client = this;
        for (const name of Object.keys(this.protocols)) {
            try {
                this.registerServiceBroker(name, isMobile);
            }
            catch (err) {
                client[name] = { version: 0 };
            }
        }
    }
    registerServiceBroker(name, isMobile) {
        const client = this;
        const MegaBroker = useMegaBroker();
        if (!MegaBroker) {
            throw new Error('missing mega broker in global context');
        }
        const { protocol, broker } = MegaBroker.loadProtocol(name);
        const { apis, channels, version } = protocol;
        client[name] = { version };
        for (const apiKey of apis) {
            client[name][apiKey] = broker[apiKey];
        }
        for (const channelKey of channels) {
            client[name][channelKey] = (...args) => __awaiter(this, void 0, void 0, function* () {
                const { token } = yield broker[channelKey](...args);
                return isMobile ? new ClientChannelMobile(token) : new ClientChannel(token);
            });
        }
    }
}
export default Client;
//# sourceMappingURL=client.js.map